'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var utilities = require('@jauntin/utilities');
var reactCookie = require('react-cookie');
var tk = require('timekeeper');
var Select = require('react-select');
var PlacesAutocomplete = require('react-places-autocomplete');
var SignaturePadModule = require('signature_pad');
var reactDayPicker = require('react-day-picker');
require('react-day-picker/dist/style.css');
var reactBootstrap = require('react-bootstrap');
var dateFns = require('date-fns');
var dateFnsTz = require('date-fns-tz');
var update = require('immutability-helper');
var reactDnd = require('react-dnd');
var reactDndHtml5Backend = require('react-dnd-html5-backend');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var tk__default = /*#__PURE__*/_interopDefaultLegacy(tk);
var Select__default = /*#__PURE__*/_interopDefaultLegacy(Select);
var PlacesAutocomplete__default = /*#__PURE__*/_interopDefaultLegacy(PlacesAutocomplete);
var SignaturePadModule__default = /*#__PURE__*/_interopDefaultLegacy(SignaturePadModule);
var update__default = /*#__PURE__*/_interopDefaultLegacy(update);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var usePollDocuments = function (_a) {
    var getDocumentsStatus = _a.getDocumentsStatus, getDocuments = _a.getDocuments, fileDownloadName = _a.fileDownloadName, downloadFn = _a.downloadFn, onDownloaded = _a.onDownloaded, onError = _a.onError, interval = _a.interval, maxAttempts = _a.maxAttempts;
    var _b = React.useState(false), downloading = _b[0], setDownloading = _b[1];
    var downloadDocument = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getDocuments()];
                case 1:
                    data = (_a.sent()).data;
                    downloadFn(data, fileDownloadName);
                    setDownloading(false);
                    onDownloaded && onDownloaded();
                    return [2 /*return*/];
            }
        });
    }); };
    var startDownload = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setDownloading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, utilities.poll({
                            fn: function () { return __awaiter(void 0, void 0, void 0, function () {
                                var data;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, getDocumentsStatus()];
                                        case 1:
                                            data = (_a.sent()).data;
                                            return [2 /*return*/, data];
                                    }
                                });
                            }); },
                            validate: function (result) { return result; },
                            interval: interval,
                            maxAttempts: maxAttempts
                        })];
                case 2:
                    response = _b.sent();
                    if (!response) return [3 /*break*/, 4];
                    return [4 /*yield*/, downloadDocument()];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    _b.sent();
                    setDownloading(false);
                    onError && onError();
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return {
        downloading: downloading,
        startDownload: startDownload
    };
};

var useTimeTravel = function (enabled) {
    var cookies = reactCookie.useCookies(['current_app_date'])[0];
    React.useEffect(function () {
        var currentAppDate = cookies.current_app_date;
        if (currentAppDate && enabled) {
            var currentDate = new Date();
            tk__default["default"].freeze(new Date("".concat(currentAppDate, " ").concat(currentDate.getHours(), ":").concat(currentDate.getMinutes(), ":").concat(currentDate.getSeconds())));
        }
        return function () { return tk__default["default"].reset(); };
    }, [cookies, enabled]);
};

var LOCATION_CHANGE = 'LOCATION_CHANGE';
var locationChange = function (location) { return ({
    type: LOCATION_CHANGE,
    payload: { location: location }
}); };
var HISTORY_PUSH = 'HISTORY_PUSH';
var push = function (pathname) { return ({
    type: HISTORY_PUSH,
    payload: pathname
}); };
var routerReducer = function (state, action) {
    if (state === void 0) { state = {
        location: {
            pathname: '',
            search: '',
            hash: '',
            key: '',
            query: {}
        },
        pushUrl: null
    }; }
    switch (action.type) {
        case LOCATION_CHANGE:
            var location_1 = action.payload.location;
            return __assign(__assign({}, state), { location: __assign(__assign({}, location_1), { query: Object.fromEntries(new URLSearchParams(location_1.search).entries()) }) });
        case HISTORY_PUSH:
            return __assign(__assign({}, state), { pushUrl: action.payload });
        default:
            return state;
    }
};
var ConnectedRouter = function (_a) {
    var children = _a.children, dispatch = _a.dispatch, location = _a.location, pushUrl = _a.pushUrl, history = _a.history;
    React.useEffect(function () {
        if (pushUrl !== null) {
            history.push(pushUrl);
            dispatch(push(null));
        }
    }, [location, pushUrl, history, dispatch]);
    React.useEffect(function () {
        dispatch(locationChange(location));
    }, [location, dispatch]);
    return children;
};

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    LOCATION_CHANGE: LOCATION_CHANGE,
    HISTORY_PUSH: HISTORY_PUSH,
    push: push,
    routerReducer: routerReducer,
    Router: ConnectedRouter
});

var showErrors = function (meta) {
    return meta.touched && !!meta.error;
};

// TODO: error messages will be consolidated in GG User frontend upgrade
var msgMap = {
    required: 'Required',
    email: 'Invalid email address',
    phoneNumber: 'Invalid phone number, must be 10 digits',
    zipCode: "Invalid, must be 5 digits",
    maxAttendees: 'Total event attendance cannot exceed 5000',
    minValue1: 'Must be at least 1',
    creditCardNumber: 'Invalid credit card',
    facilityOtherAdditionalInsuredZipCode: 'Invalid. Valid examples: 90210 or 53203-2104'
};
var mapExtendedErrors = function (meta, options) {
    var errorMsg;
    var errorMessages = __assign(__assign({}, msgMap), options === null || options === void 0 ? void 0 : options.messages);
    if (meta.errors) {
        var firstErrorKey = Object.keys(meta.errors).find(function (key) { return meta.errors[key]; });
        errorMsg = firstErrorKey
            ? errorMessages[firstErrorKey] || 'Error'
            : undefined;
    }
    else {
        errorMsg = meta.error;
    }
    var result = __assign(__assign({}, meta), { error: errorMsg });
    return result;
};

var IntegerNumberInput = function (_a) {
    var input = _a.input, meta = _a.meta, label = _a.label, subtext = _a.subtext, placeholder = _a.placeholder, required = _a.required, className = _a.className, min = _a.min, max = _a.max, disabled = _a.disabled, inputClassName = _a.inputClassName, errorClassName = _a.errorClassName, labelClassName = _a.labelClassName, subtextClassName = _a.subtextClassName, _b = _a.showErrors, showErrors$1 = _b === void 0 ? showErrors : _b;
    var mappedMeta = mapExtendedErrors(meta);
    var integerKeyPressOnly = function (event) {
        var result = 
        // Allow Digits 0-9
        (event.charCode >= 48 && event.charCode <= 57) ||
            // Allow Enter button
            event.charCode === 13 ||
            // Allow/Disable Minus Key
            ((min === undefined || min < 0) && event.charCode === 45);
        if (!result)
            event.preventDefault();
    };
    var numberInputOnWheelPreventChange = function (e) {
        // Prevent the input value change
        e.currentTarget.blur();
        // Prevent the page/container scrolling
        e.stopPropagation();
        e.persist();
    };
    return (React__default["default"].createElement("div", { className: utilities.classname('form-group', className) },
        label && (React__default["default"].createElement("label", { htmlFor: input.name, className: utilities.classname('label', showErrors$1(mappedMeta) && 'form-error__label', labelClassName) }, label)),
        showErrors$1(mappedMeta) && (React__default["default"].createElement("div", { className: utilities.classname('form-error', errorClassName) }, mappedMeta.error)),
        subtext && (React__default["default"].createElement("div", { className: utilities.classname('label__subtext', subtextClassName) }, subtext)),
        React__default["default"].createElement("input", __assign({ id: input.name, type: "number", pattern: "\\d*", onKeyPress: integerKeyPressOnly, min: min, max: max, onWheel: numberInputOnWheelPreventChange }, input, { "aria-label": placeholder, className: utilities.classname('form-control', inputClassName), placeholder: placeholder, required: required, disabled: disabled }))));
};

var InputMode;
(function (InputMode) {
    InputMode["None"] = "none";
    InputMode["Text"] = "text";
    InputMode["Tel"] = "tel";
    InputMode["Url"] = "url";
    InputMode["Email"] = "email";
    InputMode["Numeric"] = "numeric";
    InputMode["Decimal"] = "decimal";
    InputMode["Search"] = "search";
})(InputMode || (InputMode = {}));
var TextInput = function (_a) {
    var input = _a.input, meta = _a.meta, label = _a.label, subtext = _a.subtext, placeholder = _a.placeholder, required = _a.required, maxLength = _a.maxLength, disabled = _a.disabled, readOnly = _a.readOnly, pattern = _a.pattern, inputMode = _a.inputMode, ariaLabel = _a.ariaLabel, className = _a.className, wrapperClassName = _a.wrapperClassName, inputClassName = _a.inputClassName, errorClassName = _a.errorClassName, lengthClassName = _a.lengthClassName, labelClassName = _a.labelClassName, subtextClassName = _a.subtextClassName, _b = _a.showErrors, showErrors$1 = _b === void 0 ? showErrors : _b;
    var mappedMeta = mapExtendedErrors(meta);
    return (React__default["default"].createElement("div", { className: utilities.classname('form-group', className, wrapperClassName) },
        label && (React__default["default"].createElement("label", { htmlFor: input.name, className: utilities.classname('label', showErrors$1(mappedMeta) && 'form-error__label', labelClassName) }, label)),
        showErrors$1(mappedMeta) && (React__default["default"].createElement("div", { className: utilities.classname('form-error', errorClassName) }, mappedMeta.error)),
        subtext && (React__default["default"].createElement("div", { className: utilities.classname('label__subtext', subtextClassName) }, subtext)),
        React__default["default"].createElement("input", __assign({}, input, { id: input.name, type: "text", pattern: pattern, inputMode: inputMode, maxLength: maxLength, "aria-label": ariaLabel, placeholder: placeholder, required: required, readOnly: readOnly, disabled: disabled, className: utilities.classname('form-control', inputClassName) })),
        maxLength > 0 && (React__default["default"].createElement("div", { className: utilities.classname('text-right', lengthClassName) },
            (input.value && String(input.value).length) || 0,
            "/",
            maxLength,
            ' ',
            "characters"))));
};

var EmailInput = function (_a) {
    var input = _a.input, meta = _a.meta, _b = _a.label, label = _b === void 0 ? 'Email' : _b, subtext = _a.subtext, _c = _a.placeholder, placeholder = _c === void 0 ? 'your@email.com' : _c, required = _a.required, disabled = _a.disabled, readOnly = _a.readOnly, _d = _a.ariaLabel, ariaLabel = _d === void 0 ? 'Email' : _d, className = _a.className, wrapperClassName = _a.wrapperClassName, inputClassName = _a.inputClassName, errorClassName = _a.errorClassName, labelClassName = _a.labelClassName, subtextClassName = _a.subtextClassName, _e = _a.showErrors, showErrors$1 = _e === void 0 ? showErrors : _e;
    var mappedMeta = mapExtendedErrors(meta);
    return (React__default["default"].createElement("div", { className: utilities.classname('form-group', className, wrapperClassName) },
        label && (React__default["default"].createElement("label", { htmlFor: input.name, className: utilities.classname('label', showErrors$1(mappedMeta) && 'form-error__label', labelClassName) }, label)),
        showErrors$1(mappedMeta) && (React__default["default"].createElement("div", { className: utilities.classname('form-error', errorClassName) }, mappedMeta.error)),
        subtext && (React__default["default"].createElement("div", { className: utilities.classname('label__subtext', subtextClassName) }, subtext)),
        React__default["default"].createElement("input", __assign({}, input, { id: input.name, type: "email", "aria-label": ariaLabel, placeholder: placeholder, required: required, readOnly: readOnly, disabled: disabled, className: utilities.classname('form-control', inputClassName) }))));
};

var PhoneInput = function (_a) {
    var input = _a.input, meta = _a.meta, _b = _a.label, label = _b === void 0 ? 'Phone' : _b, subtext = _a.subtext, _c = _a.placeholder, placeholder = _c === void 0 ? '(XXX) XXX-XXXX' : _c, required = _a.required, disabled = _a.disabled, readOnly = _a.readOnly, _d = _a.ariaLabel, ariaLabel = _d === void 0 ? 'Phone' : _d, className = _a.className, wrapperClassName = _a.wrapperClassName, inputClassName = _a.inputClassName, errorClassName = _a.errorClassName, labelClassName = _a.labelClassName, subtextClassName = _a.subtextClassName, _e = _a.showErrors, showErrors$1 = _e === void 0 ? showErrors : _e;
    var mappedMeta = mapExtendedErrors(meta);
    return (React__default["default"].createElement("div", { className: utilities.classname('form-group', className, wrapperClassName) },
        label && (React__default["default"].createElement("label", { htmlFor: input.name, className: utilities.classname('label', showErrors$1(mappedMeta) && 'form-error__label', labelClassName) }, label)),
        showErrors$1(mappedMeta) && (React__default["default"].createElement("div", { className: utilities.classname('form-error', errorClassName) }, mappedMeta.error)),
        subtext && (React__default["default"].createElement("div", { className: utilities.classname('label__subtext', subtextClassName) }, subtext)),
        React__default["default"].createElement("input", __assign({}, input, { id: input.name, type: "tel", "aria-label": ariaLabel, placeholder: placeholder, required: required, readOnly: readOnly, disabled: disabled, className: utilities.classname('form-control', inputClassName) }))));
};

var CheckboxInput = function (_a) {
    var input = _a.input, meta = _a.meta, label = _a.label, _b = _a.disabled, disabled = _b === void 0 ? false : _b, ariaLabel = _a.ariaLabel, inputClassName = _a.inputClassName, labelClassName = _a.labelClassName, errorClassName = _a.errorClassName, className = _a.className, _c = _a.showErrors, showErrors$1 = _c === void 0 ? showErrors : _c;
    var mappedMeta = mapExtendedErrors(meta);
    return (React__default["default"].createElement("div", { className: "form-group" },
        showErrors$1(mappedMeta) && (React__default["default"].createElement("div", { className: utilities.classname('form-error', errorClassName) }, mappedMeta.error)),
        React__default["default"].createElement("div", { className: utilities.classname('custom-control custom-checkbox', className) },
            React__default["default"].createElement("input", __assign({}, input, { id: input.name, type: "checkbox", disabled: disabled, "aria-label": ariaLabel, className: utilities.classname('custom-control-input', inputClassName), checked: Boolean(input.value) })),
            React__default["default"].createElement("label", { htmlFor: input.name, className: utilities.classname('custom-control-label', labelClassName, showErrors$1(mappedMeta) && 'form-error__label') }, label))));
};

var SelectList = function (_a) {
    var options = _a.options, input = _a.input, disabled = _a.disabled, placeholder = _a.placeholder, searchable = _a.searchable, customStyles = _a.customStyles, _b = _a.onChange, onChange = _b === void 0 ? undefined : _b;
    // Options are defined in terms of their { value: , label: } object
    // this pulls the option whose value property equals the value argument
    var getOptionFromValue = function (value) {
        return options.reduce(function (carry, current) { return (current.value === value ? current : carry); }, null);
    };
    return (React__default["default"].createElement(Select__default["default"], { options: options, id: input.name, isDisabled: disabled, className: "w-100", value: getOptionFromValue(input.value), onChange: function (v) {
            if (onChange) {
                onChange(v.value);
                return;
            }
            input.onChange && input.onChange(v.value);
        }, onBlur: function () { return input.onBlur && input.onBlur(null); }, styles: customStyles, isClearable: false, isSearchable: searchable, placeholder: placeholder }));
};

var NoteTypes;
(function (NoteTypes) {
    NoteTypes["Automatic"] = "automatic";
    NoteTypes["Manual"] = "manual";
})(NoteTypes || (NoteTypes = {}));
var Note = function (_a) {
    var message = _a.message, created = _a.created, type = _a.type, _b = _a.userName, userName = _b === void 0 ? null : _b, orderNumber = _a.orderNumber;
    return (React__default["default"].createElement("div", { className: "note mb-5" },
        React__default["default"].createElement("p", null, message),
        React__default["default"].createElement("div", { className: "note__footer mt-2" },
            React__default["default"].createElement("em", null,
                (type === NoteTypes.Manual && 'Manual') || 'Automatic',
                ' note - ',
                utilities.dateHelpers.lettersAndNumbers(created),
                ' at ',
                utilities.dateHelpers.simpleTime(created),
                userName && " by ".concat(userName),
                orderNumber && " - Ref. Number ".concat(orderNumber)))));
};

var NotesContainer = function (_a) {
    var entityId = _a.entityId, publish = _a.publish, notes = _a.notes;
    var _b = React.useState(''), message = _b[0], setMessage = _b[1];
    var _c = React.useState(false), editing = _c[0], setEditing = _c[1];
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("div", { className: "content__header" },
            React__default["default"].createElement("div", { className: "d-flex justify-content-between align-items-center" },
                React__default["default"].createElement("h4", { className: "m-0 font-weight-bold" }, "Notes & History"),
                !editing && (React__default["default"].createElement("button", { className: "btn btn-primary px-4", onClick: function () {
                        setEditing(true);
                        setMessage('');
                    }, type: "button" }, "Add Note")))),
        React__default["default"].createElement("div", { className: "content__body" },
            editing && (React__default["default"].createElement("div", { className: "mb-5" },
                React__default["default"].createElement("div", { className: "mb-2" },
                    React__default["default"].createElement("strong", null, "Add a manual note")),
                React__default["default"].createElement("textarea", { className: "form-control form-control-lg mb-4", placeholder: "Write your message here", "aria-label": "Write your message here", onChange: function (e) { return setMessage(e.target.value); }, value: message, rows: 4 }),
                React__default["default"].createElement("div", { className: "text-right" },
                    React__default["default"].createElement("button", { type: "button", onClick: function () { return setEditing(false); }, className: "btn btn-outline-secondary px-4 mx-4" }, "Discard"),
                    React__default["default"].createElement("button", { type: "button", onClick: function () {
                            void publish(entityId, message).then(function () { return setEditing(false); });
                        }, disabled: !Boolean(message), className: "btn btn-primary px-4" }, "Publish")))),
            notes
                .slice(0)
                .reverse()
                .map(function (m) { return (React__default["default"].createElement(Note, { key: m.id, message: m.message, type: m.type, orderNumber: m.orderNumber, created: m.created, userName: m.userName })); }))));
};

var CardNumberInput = function (_a) {
    var input = _a.input, meta = _a.meta, _b = _a.label, label = _b === void 0 ? 'Card Number' : _b, subtext = _a.subtext, _c = _a.placeholder, placeholder = _c === void 0 ? '0000 0000 0000 0000' : _c, required = _a.required, disabled = _a.disabled, readOnly = _a.readOnly, _d = _a.ariaLabel, ariaLabel = _d === void 0 ? 'Credit Card Number' : _d, className = _a.className, wrapperClassName = _a.wrapperClassName, inputClassName = _a.inputClassName, errorClassName = _a.errorClassName, labelClassName = _a.labelClassName, subtextClassName = _a.subtextClassName, _e = _a.showErrors, showErrors$1 = _e === void 0 ? showErrors : _e;
    var mappedMeta = mapExtendedErrors(meta);
    return (React__default["default"].createElement("div", { className: utilities.classname('form-group', className, wrapperClassName) },
        label && (React__default["default"].createElement("label", { htmlFor: input.name, className: utilities.classname('label', showErrors$1(mappedMeta) && 'form-error__label', labelClassName) }, label)),
        showErrors$1(mappedMeta) && (React__default["default"].createElement("div", { className: utilities.classname('form-error', errorClassName) }, mappedMeta.error)),
        subtext && (React__default["default"].createElement("div", { className: utilities.classname('label__subtext', subtextClassName) }, subtext)),
        React__default["default"].createElement("input", __assign({}, input, { id: input.name, type: "tel", inputMode: "numeric", "aria-label": ariaLabel, placeholder: placeholder, required: required, readOnly: readOnly, disabled: disabled, className: utilities.classname('form-control', inputClassName) }))));
};

var CardCVVInput = function (_a) {
    var input = _a.input, meta = _a.meta, _b = _a.label, label = _b === void 0 ? 'Security Code' : _b, subtext = _a.subtext, _c = _a.placeholder, placeholder = _c === void 0 ? 'CVV' : _c, required = _a.required, disabled = _a.disabled, readOnly = _a.readOnly, _d = _a.ariaLabel, ariaLabel = _d === void 0 ? 'CVV' : _d, className = _a.className, wrapperClassName = _a.wrapperClassName, inputClassName = _a.inputClassName, errorClassName = _a.errorClassName, labelClassName = _a.labelClassName, subtextClassName = _a.subtextClassName, _e = _a.showErrors, showErrors$1 = _e === void 0 ? showErrors : _e, onChange = _a.onChange;
    var mappedMeta = mapExtendedErrors(meta, {
        messages: {
            creditCardCvv: 'Invalid CVV'
        }
    });
    return (React__default["default"].createElement("div", { className: utilities.classname('form-group', className, wrapperClassName) },
        label && (React__default["default"].createElement("label", { htmlFor: input.name, className: utilities.classname('label', showErrors$1(mappedMeta) && 'form-error__label', labelClassName) }, label)),
        showErrors$1(mappedMeta) && (React__default["default"].createElement("div", { className: utilities.classname('form-error', errorClassName) }, mappedMeta.error)),
        subtext && (React__default["default"].createElement("div", { className: utilities.classname('label__subtext', subtextClassName) }, subtext)),
        React__default["default"].createElement("input", __assign({}, input, { id: input.name, type: "tel", inputMode: "numeric", pattern: "\\d*", "aria-label": ariaLabel, placeholder: placeholder, required: required, readOnly: readOnly, disabled: disabled, className: utilities.classname('form-control', inputClassName), onChange: function (e) {
                if (onChange) {
                    onChange(e);
                }
                else {
                    input.onChange && input.onChange(e);
                }
            } }))));
};

var Button = function (_a) {
    var text = _a.text, onClick = _a.onClick, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.show, show = _c === void 0 ? true : _c, className = _a.className, _d = _a.type, type = _d === void 0 ? 'button' : _d;
    return show && (React__default["default"].createElement("button", { disabled: disabled, className: utilities.classname('btn', className), onClick: onClick, type: type }, text));
};

var AsyncButton = function (_a) {
    var onClick = _a.onClick, _b = _a.spinning, spinning = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, className = _a.className, children = _a.children, spinningText = _a.spinningText, _d = _a.type, type = _d === void 0 ? 'button' : _d, spinnerClassName = _a.spinnerClassName, textClassName = _a.textClassName, contentClassName = _a.contentClassName;
    return (React__default["default"].createElement("button", { type: type, onClick: onClick, disabled: disabled || spinning, className: utilities.classname('async-button', className, spinning ? 'async-button--spinning' : '') },
        spinning && (React__default["default"].createElement("div", { className: utilities.classname('async-button__spinner', spinnerClassName) },
            React__default["default"].createElement("span", { className: "spinner-border" }),
            spinningText && (React__default["default"].createElement("span", { className: utilities.classname('async-button__spinning-text', textClassName) }, spinningText)))),
        children && (React__default["default"].createElement("span", { className: utilities.classname('content', contentClassName) }, children))));
};

var CloseButton = function (_a) {
    var onClick = _a.onClick, className = _a.className;
    return (React__default["default"].createElement(Button, { className: className, onClick: onClick, text: React__default["default"].createElement("i", { className: "fal fa-times alert__close" }) }));
};

var calculatePagination = function (pagination, displayPages) {
    var maxPages = displayPages;
    var startIndex = 1;
    var endIndex = maxPages;
    if (pagination.totalPages <= maxPages) {
        endIndex = pagination.totalPages;
        maxPages = endIndex;
    }
    else if (pagination.page <= Math.ceil(maxPages / 2)) {
        startIndex = 1;
        endIndex = maxPages;
    }
    else if (pagination.page >=
        pagination.totalPages - Math.floor(maxPages / 2)) {
        startIndex = pagination.totalPages - maxPages + 1;
        endIndex = pagination.totalPages;
    }
    else {
        startIndex = pagination.page - Math.floor(maxPages / 2);
        endIndex = pagination.page + Math.floor(maxPages / 2);
        if (maxPages % 2 === 0) {
            startIndex++; // Adjust startIndex for even maxPages
        }
    }
    return [startIndex, endIndex];
};

var PageButtons = function (_a) {
    var pagination = _a.pagination, goToPage = _a.goToPage, _b = _a.displayPages, displayPages = _b === void 0 ? 3 : _b;
    var pageButtons = [];
    var _c = calculatePagination(pagination, displayPages), startIndex = _c[0], endIndex = _c[1];
    var _loop_1 = function (page) {
        var selectedPage = '';
        var isCurrentPage = pagination.page === page;
        if (isCurrentPage) {
            selectedPage = 'btn-page--selected';
        }
        pageButtons.push(React__default["default"].createElement(Button, { key: "page".concat(page), text: String(page), onClick: function () {
                if (!isCurrentPage) {
                    goToPage(page);
                }
            }, className: "btn-page ".concat(selectedPage) }));
    };
    for (var page = startIndex; page <= endIndex; page += 1) {
        _loop_1(page);
    }
    return React__default["default"].createElement(React__default["default"].Fragment, null, pageButtons);
};
var Pagination = function (_a) {
    var pagination = _a.pagination, goToPage = _a.goToPage, _b = _a.displayPages, displayPages = _b === void 0 ? 3 : _b;
    var disablePrevBtns = pagination.page <= 1;
    var disableNextBtns = pagination.page >= pagination.totalPages;
    return (React__default["default"].createElement("div", { className: "d-flex" },
        React__default["default"].createElement(Button, { text: React__default["default"].createElement(React__default["default"].Fragment, null,
                React__default["default"].createElement("i", { className: "far fa-angle-left" }),
                React__default["default"].createElement("i", { className: "far fa-angle-left" })), className: "btn-page btn-page--nav btn-page--left", disabled: disablePrevBtns, onClick: function () { return goToPage(1); } }),
        React__default["default"].createElement(Button, { text: React__default["default"].createElement("i", { className: "far fa-angle-left" }), className: "btn-page btn-page--nav", disabled: disablePrevBtns, onClick: function () {
                goToPage(pagination.page - 1);
            } }),
        React__default["default"].createElement(PageButtons, { pagination: pagination, goToPage: goToPage, displayPages: displayPages }),
        React__default["default"].createElement(Button, { text: React__default["default"].createElement("i", { className: "far fa-angle-right" }), className: "btn-page btn-page--nav", disabled: disableNextBtns, onClick: function () {
                goToPage(pagination.page + 1);
            } }),
        React__default["default"].createElement(Button, { text: React__default["default"].createElement(React__default["default"].Fragment, null,
                React__default["default"].createElement("i", { className: "far fa-angle-right" }),
                React__default["default"].createElement("i", { className: "far fa-angle-right" })), disabled: disableNextBtns, className: "btn-page btn-page--nav btn-page--right", onClick: function () { return goToPage(pagination.totalPages); } })));
};

// Ensure Google Maps Api is loaded before rendering this component
var PlacesSearch = function (_a) {
    var _b;
    var input = _a.input, meta = _a.meta, _c = _a.placeholder, placeholder = _c === void 0 ? 'Search by venue name or address' : _c, label = _a.label, className = _a.className, _d = _a.hasInput, hasInput = _d === void 0 ? false : _d, _e = _a.readOnly, readOnly = _e === void 0 ? false : _e, _f = _a.showSearchIcon, showSearchIcon = _f === void 0 ? true : _f, onSelect = _a.onSelect, onChangeValue = _a.onChangeValue, onKeyDownInput = _a.onKeyDownInput, clearForm = _a.clearForm, onBlurInput = _a.onBlurInput, onFocusInput = _a.onFocusInput, _g = _a.searchCountries, searchCountries = _g === void 0 ? ['us'] : _g, _h = _a.usTerritories, usTerritories = _h === void 0 ? ['PR', 'VI'] : _h;
    var mappedMeta = mapExtendedErrors(meta);
    var inputRef = React.useRef(null);
    return (React__default["default"].createElement(PlacesAutocomplete__default["default"], { value: String(((_b = input.value) === null || _b === void 0 ? void 0 : _b.name) || ''), onSelect: function (placeName, placeId) {
            // Submits change with new value, and then runs the custom onSelect
            input.onChange({
                name: placeName
            });
            if (inputRef.current) {
                var places = new google.maps.places.PlacesService(inputRef.current);
                places.getDetails({
                    placeId: placeId,
                    fields: [
                        'address_components',
                        'formatted_address',
                        'utc_offset_minutes',
                        'types',
                        'name',
                    ]
                }, function (place, status) {
                    if (status !== google.maps.places.PlacesServiceStatus.OK) {
                        return;
                    }
                    var address = place.formatted_address;
                    var locationTypes = place.types;
                    // Send location types and address to parser to test for corner case
                    var addressComponents = utilities.parseAddress(place.address_components, locationTypes, address, place.name, usTerritories);
                    var utcOffset = place.utc_offset_minutes;
                    onSelect(placeId, address, addressComponents, utcOffset, placeName);
                    input.onChange({
                        name: placeName,
                        address: addressComponents,
                        placeId: placeId
                    });
                });
            }
        }, onChange: function (value) {
            if (onChangeValue) {
                onChangeValue(value);
            }
            input.onChange({
                name: value
            });
        }, searchOptions: {
            componentRestrictions: { country: searchCountries }
        } }, function (_a) {
        var getInputProps = _a.getInputProps, suggestions = _a.suggestions, getSuggestionItemProps = _a.getSuggestionItemProps, loading = _a.loading;
        return (React__default["default"].createElement("div", { className: utilities.classname('venueInput', className) },
            label && (React__default["default"].createElement("label", { htmlFor: "fieldVenue", className: mappedMeta.touched && mappedMeta.error
                    ? 'label form-error__label'
                    : 'label' }, label)),
            mappedMeta.touched && mappedMeta.error && (React__default["default"].createElement("div", { className: "form-error" }, mappedMeta.error)),
            React__default["default"].createElement("div", { className: "venueInput__field" },
                showSearchIcon && React__default["default"].createElement("i", { className: "fal fa-search" }),
                hasInput && (React__default["default"].createElement(Button, { onClick: function () {
                        clearForm();
                    }, text: React__default["default"].createElement("i", { className: 'fal fa-times' }) })),
                React__default["default"].createElement("input", __assign({}, getInputProps({
                    id: 'fieldVenue',
                    className: 'form-control form-control-lg',
                    'aria-label': placeholder,
                    placeholder: placeholder,
                    readOnly: readOnly,
                    onKeyDown: function (_a) {
                        var key = _a.key;
                        if (onKeyDownInput) {
                            onKeyDownInput(key);
                        }
                    },
                    onFocus: function () {
                        if (onFocusInput) {
                            onFocusInput();
                        }
                    },
                    onBlur: function (e) {
                        if (onBlurInput) {
                            onBlurInput(e);
                        }
                    },
                    ref: inputRef
                }))),
                React__default["default"].createElement("div", { className: "autocomplete-dropdown-container dropdown-menu ".concat(suggestions.length > 0 ? "show" : '') },
                    loading && React__default["default"].createElement("div", null, "Loading..."),
                    suggestions.map(function (suggestion) {
                        var className = suggestion.active
                            ? 'dropdown-item active'
                            : 'dropdown-item';
                        return (React__default["default"].createElement("div", __assign({}, getSuggestionItemProps(suggestion, {
                            className: className
                        }), { title: suggestion.description, key: suggestion.placeId }),
                            React__default["default"].createElement("span", null, suggestion.description)));
                    })))));
    }));
};

var SignaturePad = function (_a) {
    var onEndStroke = _a.onEndStroke, onClear = _a.onClear, _b = _a.dotSize, dotSize = _b === void 0 ? 0.5 : _b, _c = _a.minWidth, minWidth = _c === void 0 ? 0.5 : _c, _d = _a.maxWidth, maxWidth = _d === void 0 ? 2.5 : _d, _e = _a.backgroundColor, backgroundColor = _e === void 0 ? 'rgba(255, 255, 255, 0)' : _e, _f = _a.penColor, penColor = _f === void 0 ? 'rgb(0, 0, 0)' : _f, _g = _a.type, type = _g === void 0 ? 'image/png' : _g, encoderOptions = _a.encoderOptions, svgOptions = _a.svgOptions, className = _a.className, canvasClassName = _a.canvasClassName, clearClassName = _a.clearClassName;
    var _h = React.useState(null), signaturePad = _h[0], setSignaturePad = _h[1];
    var ref = React.useRef(null);
    React.useEffect(function () {
        if (ref.current) {
            var _signaturePad_1 = new SignaturePadModule__default["default"](ref.current, {
                dotSize: dotSize,
                minWidth: minWidth,
                maxWidth: maxWidth,
                backgroundColor: backgroundColor,
                penColor: penColor
            });
            _signaturePad_1.addEventListener('endStroke', function () {
                if (type === 'image/svg+xml') {
                    onEndStroke(_signaturePad_1.toDataURL(type, svgOptions));
                }
                else {
                    onEndStroke(_signaturePad_1.toDataURL(type, encoderOptions));
                }
            });
            setSignaturePad(_signaturePad_1);
            return function () { return _signaturePad_1.removeEventListener('endStroke', null); };
        }
    }, [
        dotSize,
        minWidth,
        maxWidth,
        backgroundColor,
        penColor,
        type,
        onEndStroke,
        svgOptions,
        encoderOptions,
    ]);
    return (React__default["default"].createElement("div", { className: className },
        React__default["default"].createElement("canvas", { className: canvasClassName, ref: ref }),
        React__default["default"].createElement("button", { className: clearClassName, onClick: function () {
                if (signaturePad) {
                    signaturePad.clear();
                    onClear();
                }
            } }, "Clear")));
};

var ContactCards = function (_a) {
    var contacts = _a.contacts, cardTitle = _a.cardTitle, className = _a.className, cardClassName = _a.cardClassName, headerClassName = _a.headerClassName, bodyClassName = _a.bodyClassName;
    return (React__default["default"].createElement("div", { className: utilities.classname('contact-cards', className) }, contacts.map(function (contact, i) { return (React__default["default"].createElement("div", { key: i, className: utilities.classname('contact-card', 'card', cardClassName) },
        React__default["default"].createElement("div", { className: utilities.classname('card-header', headerClassName) },
            React__default["default"].createElement("div", { className: "contact-card__title" }, "".concat(cardTitle, " #").concat(i + 1))),
        React__default["default"].createElement("div", { className: utilities.classname('card-body', bodyClassName) },
            contact.fullName && (React__default["default"].createElement("div", { className: "contact-card__fullname" }, contact.fullName)),
            contact.role && (React__default["default"].createElement("div", { className: "contact-card__role" }, contact.role)),
            React__default["default"].createElement("div", { className: "contact-card__email" }, contact.email),
            contact.hasOwnProperty('copyOnEmails') && (React__default["default"].createElement(React__default["default"].Fragment, null,
                React__default["default"].createElement("div", { className: "mb-4" }),
                React__default["default"].createElement("div", { className: "contact-card__label-copy" }, "Copied on email containing coverage information"),
                React__default["default"].createElement("div", { className: "contact-card__copy" }, contact.copyOnEmails ? 'Yes' : 'No')))))); })));
};

var DefaultTimezoneContext = React.createContext(null);
var DefaultTimezoneProvider = function (_a) {
    var children = _a.children, timezone = _a.timezone;
    return (React__default["default"].createElement(DefaultTimezoneContext.Provider, { value: timezone }, children));
};

// ACTIONS
var SET_FOCUSED_INPUT = 'SET_FOCUSED_INPUT';
var setFocusedInput = function (focusedInput, dateRange) { return ({
    type: SET_FOCUSED_INPUT,
    payload: {
        focusedInput: focusedInput,
        dateRange: dateRange
    }
}); };
var SET_MONTH = 'SET_MONTH';
var setMonth = function (month) { return ({
    type: SET_MONTH,
    payload: month
}); };
var HIDE_DATE_PICKER = 'HIDE_DATE_PICKER';
var hideDatePicker = function () { return ({
    type: HIDE_DATE_PICKER,
    payload: undefined
}); };
var DATE_CHANGED = 'DATE_CHANGED';
var dateChanged = function (range) { return ({
    type: DATE_CHANGED,
    payload: range
}); };
var initialState = {
    focusedInput: null,
    showDatePicker: false,
    month: new Date().toISOString()
};
var dateRangePickerReducer = function (state, action) {
    var showDatePicker = function (focusedInput) {
        return focusedInput !== null;
    };
    switch (action.type) {
        case SET_FOCUSED_INPUT:
            var _a = action.payload, focusedInput = _a.focusedInput, dateRange = _a.dateRange;
            var newMonth = void 0;
            if (focusedInput === 'startDate' && dateRange.from) {
                newMonth = dateRange.from.toISOString();
            }
            else if (focusedInput === 'endDate' && dateRange.to) {
                newMonth = dateRange.to.toISOString();
            }
            else {
                newMonth = state.month;
            }
            return __assign(__assign({}, state), { focusedInput: dateRange.from ? focusedInput : 'startDate', showDatePicker: showDatePicker(focusedInput), month: newMonth });
        case SET_MONTH:
            var month = action.payload;
            return __assign(__assign({}, state), { month: month });
        case DATE_CHANGED:
            if (!state.showDatePicker)
                return state;
            var from = action.payload.from;
            var newFocusedInput = state.focusedInput === 'startDate'
                ? 'endDate'
                : Boolean(from)
                    ? null
                    : 'startDate';
            return __assign(__assign({}, state), { focusedInput: newFocusedInput, showDatePicker: showDatePicker(newFocusedInput) });
        case HIDE_DATE_PICKER:
            return __assign(__assign({}, state), { focusedInput: null, showDatePicker: false });
        default:
            return state;
    }
};
var DateRangePicker = function (_a) {
    var className = _a.className, meta = _a.meta, input = _a.input, _b = _a.numberOfMonths, numberOfMonths = _b === void 0 ? 2 : _b, _c = _a.startDateLabel, startDateLabel = _c === void 0 ? 'Starts' : _c, _d = _a.endDateLabel, endDateLabel = _d === void 0 ? 'Ends' : _d, _e = _a.startDatePlaceholder, startDatePlaceholder = _e === void 0 ? 'Select a date' : _e, _f = _a.endDatePlaceholder, endDatePlaceholder = _f === void 0 ? 'Select a date' : _f, _g = _a.startDateFormat, startDateFormat = _g === void 0 ? 'LLLL d, yyyy' : _g, _h = _a.endDateFormat, endDateFormat = _h === void 0 ? 'LLLL d, yyyy' : _h, labelClassName = _a.labelClassName, errorClassName = _a.errorClassName, inputClassName = _a.inputClassName, _j = _a.disabledDates, disabledDates = _j === void 0 ? function () { return function () { return false; }; } : _j, timezone = _a.timezone, disabled = _a.disabled, label = _a.label, _k = _a.showErrors, showErrors$1 = _k === void 0 ? showErrors : _k, onChange = _a.onChange;
    var _l = React.useReducer(dateRangePickerReducer, initialState), state = _l[0], dispatch = _l[1];
    var focusedInput = state.focusedInput, showDatePicker = state.showDatePicker, month = state.month;
    var sdInputRef = React.useRef(null);
    var overlayTarget = React.useRef(null);
    var edInputRef = React.useRef(null);
    var _m = React.useState(false), overlayEntered = _m[0], setOverlayEntered = _m[1];
    var defaultTimezone = React.useContext(DefaultTimezoneContext);
    timezone = timezone || defaultTimezone;
    var dateRange = React.useMemo(function () {
        return convertToDateRange(input.value, timezone);
    }, [input.value, timezone]);
    // React to date changes
    React.useEffect(function () {
        dispatch(dateChanged(dateRange));
    }, [dateRange, dispatch]);
    var mappedMeta = mapExtendedErrors(meta);
    return (React__default["default"].createElement("div", { className: utilities.classname('date-range-picker', className) },
        React__default["default"].createElement("div", { className: "form-row" },
            React__default["default"].createElement("div", { className: "col" }, label && (React__default["default"].createElement("label", { htmlFor: "picker-start-date-id", className: utilities.classname('date-range-picker__label', 'label', showErrors$1(mappedMeta) && 'form-error__label', labelClassName) }, label)))),
        React__default["default"].createElement("div", { className: "form-row" },
            React__default["default"].createElement("div", { className: "form-group col-6" },
                mappedMeta && (React__default["default"].createElement("label", { htmlFor: "picker-start-date-id", className: utilities.classname('date-range-picker__label', 'label', showErrors$1(mappedMeta) && 'form-error__label', labelClassName) }, startDateLabel)),
                mappedMeta && showErrors$1(mappedMeta) && (React__default["default"].createElement("div", { className: utilities.classname('form-error', errorClassName) }, mappedMeta.error)),
                React__default["default"].createElement("input", { id: "picker-start-date-id", disabled: disabled, className: utilities.classname('form-control', inputClassName, focusedInput === 'startDate' ? 'rdp-input-focus' : undefined), ref: sdInputRef, value: (dateRange === null || dateRange === void 0 ? void 0 : dateRange.from) ? dateFns.format(dateRange.from, startDateFormat) : '', placeholder: startDatePlaceholder, onFocus: function () {
                        dispatch(setFocusedInput('startDate', dateRange));
                    }, readOnly: true, style: { background: '#fff' } })),
            React__default["default"].createElement("span", { ref: overlayTarget }),
            React__default["default"].createElement("div", { className: "form-group col-6" },
                mappedMeta && (React__default["default"].createElement("label", { htmlFor: "picker-end-date-id", className: utilities.classname('date-range-picker__label', 'label', showErrors$1(mappedMeta) && 'form-error__label', labelClassName) }, endDateLabel)),
                mappedMeta && showErrors$1(mappedMeta) && (React__default["default"].createElement("div", { className: utilities.classname('form-error', errorClassName) }, mappedMeta.error)),
                React__default["default"].createElement("input", { id: "picker-end-date-id", disabled: disabled, className: utilities.classname('form-control', inputClassName, focusedInput === 'endDate' ? 'rdp-input-focus' : undefined), ref: edInputRef, onFocus: function () {
                        dispatch(setFocusedInput('endDate', dateRange));
                    }, value: (dateRange === null || dateRange === void 0 ? void 0 : dateRange.to) ? dateFns.format(dateRange.to, endDateFormat) : '', placeholder: endDatePlaceholder, readOnly: true, style: { background: '#fff' } }))),
        React__default["default"].createElement(reactBootstrap.Overlay, { target: overlayTarget.current, show: showDatePicker, placement: "bottom", rootClose: true, onEntered: function () { return setOverlayEntered(true); }, onExited: function () { return setOverlayEntered(false); }, onHide: function (e) {
                if (![sdInputRef.current, edInputRef.current].includes(e.target)) {
                    dispatch(hideDatePicker());
                }
            } }, function (_a) {
            _a.placement; _a.arrowProps; _a.show; _a.popper; _a.hasDoneInitialMeasure; var props = __rest(_a, ["placement", "arrowProps", "show", "popper", "hasDoneInitialMeasure"]);
            return (React__default["default"].createElement("div", __assign({}, props, { style: __assign(__assign({}, props.style), { zIndex: 1 }) }),
                React__default["default"].createElement(reactDayPicker.DayPicker, { formatters: {
                        formatWeekdayName: function (date) {
                            return dateFns.format(date, 'EEE');
                        }
                    }, mode: "range", style: { background: '#fff' }, selected: dateRange, onSelect: function (event) {
                        var dateStrings = mapDateChangeHelper({
                            event: event,
                            currentRange: dateRange,
                            focusedInput: focusedInput,
                            timezone: timezone
                        });
                        if (onChange) {
                            onChange(dateStrings);
                        }
                        else {
                            input.onChange(dateStrings);
                        }
                        // After full selection focus the end date in the DOM so user tab to next control
                        if (dateStrings.startDate && dateStrings.endDate) {
                            edInputRef.current.focus();
                        }
                    }, month: new Date(month), onMonthChange: function (_month) {
                        return dispatch(setMonth(_month.toISOString()));
                    }, numberOfMonths: numberOfMonths, disabled: disabledDates(focusedInput), components: {
                        DayContent: function (props) {
                            return (React__default["default"].createElement("span", { className: "rdp-day-content" },
                                React__default["default"].createElement(reactDayPicker.DayContent, __assign({}, props))));
                        }
                    }, 
                    // initialFocus needs to wait for the overlay to enter before applying the focus.
                    initialFocus: overlayEntered })));
        })));
};
// Helper method to adjust how react-day-picker selects date for our needs
var mapDateChangeHelper = function (_a) {
    var event = _a.event, currentRange = _a.currentRange, focusedInput = _a.focusedInput, timezone = _a.timezone;
    if (event) {
        // Find the date that has changed and update based on focusedInput
        var diff = Object.entries(event).find(function (_a) {
            var _b;
            var key = _a[0], value = _a[1];
            return (value === null || value === void 0 ? void 0 : value.getTime()) !== ((_b = currentRange[key]) === null || _b === void 0 ? void 0 : _b.getTime());
        });
        if (!diff)
            return convertToStringDateRange({
                from: currentRange.from,
                to: currentRange.to
            }, timezone);
        var newDate = diff[1];
        if (focusedInput === 'startDate') {
            return convertToStringDateRange({
                from: newDate,
                to: undefined
            }, timezone);
        }
        else {
            return convertToStringDateRange({
                from: currentRange.from,
                to: newDate
            }, timezone);
        }
    }
    else {
        // undefined event === react-day-picker clearing the dates when there is a 'from' and 'to' date, and user selects the 'from' date.
        // We want to pick the correct dates based on focused input.
        if (focusedInput === 'startDate') {
            return convertToStringDateRange({
                from: currentRange.from,
                to: undefined
            }, timezone);
        }
        else {
            return convertToStringDateRange({
                from: currentRange.from,
                to: currentRange.from
            }, timezone);
        }
    }
};
var convertToStringDateRange = function (range, timezone) {
    var result = Object.entries(range).reduce(function (acc, _a) {
        var key = _a[0], value = _a[1];
        // Map local machine date back to ISO string for specific timezone
        acc[key === 'from' ? 'startDate' : 'endDate'] = value
            ? utilities.dateHelpers.localDateToTimezonedDate(value, timezone)
            : null;
        return acc;
    }, {});
    return result;
};
var convertToDateRange = function (range, timezone) {
    var startDate = range.startDate, endDate = range.endDate;
    // Map ISO datetime string to local machine date
    var from = startDate
        ? utilities.dateHelpers.timezonedDateToLocalDate(startDate, timezone)
        : null;
    var to = endDate
        ? utilities.dateHelpers.timezonedDateToLocalDate(endDate, timezone)
        : null;
    return {
        from: from,
        to: to
    };
};

var CustomDatePicker = function (_a) {
    var _b = _a.input, value = _b.value, onChange = _b.onChange, disabledDates = _a.disabledDates, _c = _a.numberOfMonths, numberOfMonths = _c === void 0 ? 1 : _c, timezone = _a.timezone, defaultMonth = _a.defaultMonth;
    var defaultTimezone = React.useContext(DefaultTimezoneContext);
    timezone = timezone || defaultTimezone;
    var selected = React.useMemo(function () {
        return value.map(function (date) {
            return utilities.dateHelpers.timezonedDateToLocalDate(date, timezone);
        });
    }, [value, timezone]);
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(reactDayPicker.DayPicker, { mode: "multiple", defaultMonth: utilities.dateHelpers.timezonedDateToLocalDate(defaultMonth, timezone) ||
                utilities.dateHelpers.getFirstEntry(selected), selected: selected, disabled: disabledDates, numberOfMonths: numberOfMonths, onSelect: function (days) {
                onChange(days.map(function (date) {
                    return utilities.dateHelpers.localDateToTimezonedDate(date, timezone);
                }));
            }, components: {
                DayContent: function (props) {
                    return (React__default["default"].createElement("span", { className: "rdp-day-content" },
                        React__default["default"].createElement(reactDayPicker.DayContent, __assign({}, props))));
                }
            } })));
};

var TimezoneFormatted = function (_a) {
    var date = _a.date, _b = _a.format, format = _b === void 0 ? utilities.dateHelpers.LETTERS_AND_NUMBERS_FORMAT : _b, timezone = _a.timezone;
    var defaultTimezone = React.useContext(DefaultTimezoneContext);
    return React__default["default"].createElement(React__default["default"].Fragment, null, dateFnsTz.formatInTimeZone(date, timezone, format || defaultTimezone));
};

var ITEM_TYPE = 'sortable';
var SortableItem = function (_a) {
    var id = _a.id, index = _a.index, moveItem = _a.moveItem, render = _a.render;
    var ref = React.useRef(null);
    var _b = reactDnd.useDrop({
        accept: ITEM_TYPE,
        collect: function (monitor) {
            return {
                handlerId: monitor.getHandlerId()
            };
        },
        hover: function (item, monitor) {
            var _a;
            if (!ref.current) {
                return;
            }
            var fromIndex = item.index;
            var toIndex = index;
            // Don't replace items with themselves
            if (fromIndex === toIndex) {
                return;
            }
            // Determine rectangle on screen
            var hoverBoundingRect = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            // Get vertical middle
            var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            // Determine mouse position
            var clientOffset = monitor.getClientOffset();
            // Get pixels to the top
            var hoverClientY = clientOffset.y - hoverBoundingRect.top;
            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%
            // Dragging downwards
            if (fromIndex < toIndex && hoverClientY < hoverMiddleY) {
                return;
            }
            // Dragging upwards
            if (fromIndex > toIndex && hoverClientY > hoverMiddleY) {
                return;
            }
            // Time to actually perform the action
            moveItem(fromIndex, toIndex);
            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            item.index = toIndex;
        }
    }), handlerId = _b[0].handlerId, drop = _b[1];
    var _c = reactDnd.useDrag({
        type: ITEM_TYPE,
        item: function () {
            return { id: id, index: index };
        },
        collect: function (monitor) { return ({
            isDragging: monitor.isDragging()
        }); }
    }), isDragging = _c[0].isDragging, drag = _c[1];
    var opacity = isDragging ? 0 : 1;
    drag(drop(ref));
    return (React__default["default"].createElement("div", { ref: ref, style: { opacity: opacity }, "data-handler-id": handlerId }, render()));
};

var SortableContainer = function (_a) {
    var items = _a.items, onMoveEnd = _a.onMoveEnd, Component = _a.component, className = _a.className;
    var _b = React.useState([]), sortableItems = _b[0], setSortableItems = _b[1];
    React.useEffect(function () {
        setSortableItems(items);
    }, [items]);
    var moveItem = React.useCallback(function (fromIndex, toIndex) {
        // prevent from being moved to itself
        if (fromIndex === toIndex) {
            return;
        }
        setSortableItems(function (prevItems) {
            var sortedItems = update__default["default"](prevItems, {
                $splice: [
                    [fromIndex, 1],
                    [toIndex, 0, prevItems[fromIndex]],
                ]
            });
            onMoveEnd && onMoveEnd(sortedItems);
            return sortedItems;
        });
    }, [onMoveEnd]);
    var renderItem = React.useCallback(function (sortableItem, index) { return (React__default["default"].createElement(SortableItem, { key: sortableItem.id, index: index, id: sortableItem.id, moveItem: moveItem, render: function () { return React__default["default"].createElement(Component, __assign({}, sortableItem)); } })); }, [moveItem, Component]);
    return (React__default["default"].createElement(reactDnd.DndProvider, { backend: reactDndHtml5Backend.HTML5Backend },
        React__default["default"].createElement("div", { className: utilities.classname('sortable-container', className) }, sortableItems.map(renderItem))));
};

var StateField = function (_a) {
    var input = _a.input, meta = _a.meta, usStates = _a.usStates, customStyles = _a.customStyles, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.onChange, onChange = _c === void 0 ? undefined : _c;
    var mappedMeta = mapExtendedErrors(meta);
    return (React__default["default"].createElement("div", { className: "col-sm form-group" },
        React__default["default"].createElement("label", { htmlFor: input.name, className: mappedMeta.touched && mappedMeta.error
                ? 'label form-error__label'
                : 'label' }, "State"),
        mappedMeta.touched && mappedMeta.error && (React__default["default"].createElement("div", { className: "form-error" }, mappedMeta.error)),
        React__default["default"].createElement(SelectList, __assign({ options: createStateOptions(usStates) }, { input: input, meta: meta }, { searchable: true, disabled: disabled, placeholder: "State", customStyles: customStyles, onChange: onChange }))));
};
function compare(a, b) {
    // Use toUpperCase() to ignore character casing
    var stateA = a.name.toUpperCase();
    var stateB = b.name.toUpperCase();
    var comparison = 0;
    if (stateA > stateB) {
        comparison = 1;
    }
    else if (stateA < stateB) {
        comparison = -1;
    }
    return comparison;
}
var createStateOptions = function (usStates) {
    usStates.sort(compare);
    var stateOptions = usStates.reduce(function filterStates(prev, curr) {
        if (['HI', 'PR', 'VI'].indexOf(curr.code) === -1) {
            prev.push({
                value: curr.code,
                label: curr.name
            });
        }
        return prev;
    }, []);
    return stateOptions;
};

var ToastBody = function (_a) {
    var show = _a.show, autohide = _a.autohide, showCloseButton = _a.showCloseButton, text = _a.text, delay = _a.delay, onClose = _a.onClose, onCloseButtonClick = _a.onCloseButtonClick, iconClassName = _a.iconClassName, toastBodyClassName = _a.toastBodyClassName, className = _a.className;
    return (React__default["default"].createElement(reactBootstrap.Toast, { className: className, onClose: onClose, show: show, delay: delay, autohide: autohide },
        React__default["default"].createElement(reactBootstrap.Toast.Body, { className: toastBodyClassName },
            React__default["default"].createElement("div", { className: "d-flex align-items-center" },
                React__default["default"].createElement("div", { className: "col-auto" },
                    React__default["default"].createElement("i", { className: iconClassName })),
                React__default["default"].createElement("div", { className: "col" }, text),
                showCloseButton && onCloseButtonClick && (React__default["default"].createElement("div", null,
                    React__default["default"].createElement(CloseButton, { onClick: onCloseButtonClick, className: "btn-link" })))))));
};

exports.AsyncButton = AsyncButton;
exports.Button = Button;
exports.CardCVVInput = CardCVVInput;
exports.CardNumberInput = CardNumberInput;
exports.CheckboxInput = CheckboxInput;
exports.CloseButton = CloseButton;
exports.ConnectedRouter = index;
exports.ContactCards = ContactCards;
exports.CustomDatePicker = CustomDatePicker;
exports.DateRangePicker = DateRangePicker;
exports.DefaultTimezoneContext = DefaultTimezoneContext;
exports.DefaultTimezoneProvider = DefaultTimezoneProvider;
exports.EmailInput = EmailInput;
exports.IntegerNumberInput = IntegerNumberInput;
exports.Note = Note;
exports.NotesContainer = NotesContainer;
exports.Pagination = Pagination;
exports.PhoneInput = PhoneInput;
exports.PlacesSearch = PlacesSearch;
exports.SelectList = SelectList;
exports.SignaturePad = SignaturePad;
exports.SortableContainer = SortableContainer;
exports.StateField = StateField;
exports.TextInput = TextInput;
exports.TimezoneFormatted = TimezoneFormatted;
exports.ToastBody = ToastBody;
exports.mapExtendedErrors = mapExtendedErrors;
exports.usePollDocuments = usePollDocuments;
exports.useTimeTravel = useTimeTravel;
